export const accountResources = {
  'account.yourAccountSettings': 'Vos paramètres de compte',
  'account.firstName': 'Prénom',
  'account.lastName': 'Nom de famille',
  'account.email': 'Email',
  'account.role': 'Rôle',
  'account.resetPassword': 'Réinitialiser le mot de passe',
  'account.editInfo': 'Modifier les informations',
  'account.resetPasswordConfirmation': 'Voulez-vous vraiment réinitialiser votre mot de passe?',
  // TODO(EURO-23): replace with compliance-approved French copy.
  'account.login.privacyBanner.title': 'We Value Your Privacy',
  'account.login.privacyBanner.body':
    'We use essential cookies to ensure basic site functionality and enhance platform security. By continuing to log in to this site, you consent to our use of cookies and acknowledge our {privacyPolicy}, which outlines our data privacy practices and cookie usage.',
  'account.login.privacyBanner.privacyPolicy': 'Privacy Policy',
};

export type AccountResourceKey =
  | 'account.yourAccountSettings'
  | 'account.firstName'
  | 'account.lastName'
  | 'account.email'
  | 'account.role'
  | 'account.resetPassword'
  | 'account.editInfo'
  | 'account.resetPasswordConfirmation'
  | 'account.login.privacyBanner.title'
  | 'account.login.privacyBanner.body'
  | 'account.login.privacyBanner.privacyPolicy';
